<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">Filtre</h3>
          </div>
        </div>
        <div class="card-body">
          <b-row>
            <b-col lg="3" xl="3">
              <b-form-group :label="$t('offers.search')">
                <b-form-input id="input-none" class="form-control form-control-solid" :state="null" :placeholder="$t('offers.search_placeholder')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="3" xl="3">
              <b-form-group id="input-group-4" :label="$t('offers.offer_status')" label-for="input-3">
                <b-form-select
                    class="form-control form-control-solid"
                    v-model="form.offer_status_id"
                    :options="offer_status"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="3" xl="3">
              <b-form-group id="input-group-4" :label="$t('new_offer.country')" label-for="input-3">
                <b-form-select
                    class="form-control form-control-solid"
                    v-model="form.country_id"
                    :options="countries"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="3" xl="3">
              <b-form-group :label="$t('new_offer.customer_')" label-for="input-group-4" id="input-group-4">
                <b-form-select
                    class="form-control form-control-solid"
                    v-model="form.customer_id"
                    :options="customers"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="3" xl="3">
              <b-form-group label="Ay Seçimi">
                <b-form-select
                    :options="months"
                    v-model="form.month_id"
                    class="form-control form-control-solid"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="3" xl="3">
              <b-form-group label="Yıl Seçimi">
                <b-form-select
                    :options="years"
                    v-model="form.year_id"
                    class="form-control form-control-solid"
                    :placeholder="$t('general.select')"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="3" xl="3">
              <b-form-group label="Anket Durumu">
                <b-form-checkbox-group class="mt-2" id="checkbox-group-2" v-model="form.selected" name="survey_status">
                  <b-form-checkbox value="0">Canlı Anketler</b-form-checkbox>
                  <b-form-checkbox value="1">Sahadaki Anketler</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col lg="3" xl="3">
              <b-form-group :label="$t('offers.is_hidden')">
                <b-form-checkbox-group class="mt-2" id="checkbox-group-2" v-model="form.selected" name="flavour-2">
                  <b-form-checkbox value="orange">{{ $t('offers.show') }}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div class="card-footer">
          <span class="fa-pull-right">
            <button type="reset" class="btn btn-outline-primary mr-10">Temizle</button>
            <button type="submit" class="btn btn-primary">Filtrele</button>
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="danger">Red</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SSI</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/1.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589023</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <!--begin::Buttons-->
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <b-button id="message-share-box-1" class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2">
                  <i class="icon flaticon-chat"></i>
                </b-button>
                <b-popover target="message-share-box-1" triggers="hover" placement="top"  class="text-center">
                  <template v-slot:title><i class="far fa-comments mr-3"></i>Mesaj-Paylaş Kampanyası</template>
                  <div class="text-center">
                    <b-button-toolbar class="text-center table-vertical-center d-block">
                      <b-button-group size="sm" class="text-center">
                        <b-button @click="$router.push({name: 'ConfirmMessageShareCampaign'})" class="mr-2 btn-light-linkedin"><i class="fas fa-clipboard-check"></i> Onay</b-button>
                        <b-button @click="$router.push({name: 'ReportMessageShareCampaign'})" class="btn-light-linkedin"><i class="fas fa-clipboard-list"></i> Rapor</b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </div>
                </b-popover>
              </div>
              <!--end::Buttons-->
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">Araştırma</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="success">Kabul</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">2. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SLN</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/no-image.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589022</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <span v-b-modal.wave1 class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2" v-b-tooltip.html title="<strong>Wave</strong>">
                  <i class="fas fa-water"></i>
                </span>
                <b-modal hide-footer :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="wave1" title="Wave">
                  <b-row>
                    <b-col xl="12">
                      <b-button v-b-modal.add_wave variant="primary" size="sm" class="fa-pull-right mb-3"><i class="fas fa-plus mr-2"></i> Ekle</b-button>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.items"
                          :fields="report.fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="primary">İptal</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">4. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">LNK</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/3.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589021</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <b-button id="message-share-box-2" class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2">
                  <i class="icon flaticon-chat"></i>
                </b-button>
                <b-popover target="message-share-box-2" triggers="hover" placement="top"  class="text-center">
                  <template v-slot:title><i class="far fa-comments mr-3"></i>Mesaj-Paylaş Kampanyası</template>
                  <div class="text-center">
                    <b-button-toolbar class="text-center table-vertical-center d-block">
                      <b-button-group size="sm" class="text-center">
                        <b-button @click="$router.push({name: 'ConfirmMessageShareCampaign'})" class="mr-2 btn-light-linkedin"><i class="fas fa-clipboard-check"></i> Onay</b-button>
                        <b-button @click="$router.push({name: 'ReportMessageShareCampaign'})" class="btn-light-linkedin"><i class="fas fa-clipboard-list"></i> Rapor</b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </div>
                </b-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">Araştırma</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="success">Kabul</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">5. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SSI</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/4.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589020</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <span v-b-modal.wave2 class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2" v-b-tooltip.html title="<strong>Wave</strong>">
                  <i class="fas fa-water"></i>
                </span>
                <b-modal hide-footer :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="wave2" title="Wave">
                  <b-row>
                    <b-col xl="12">
                      <b-button v-b-modal.add_wave variant="primary" size="sm" class="fa-pull-right mb-3"><i class="fas fa-plus mr-2"></i> Ekle</b-button>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.items"
                          :fields="report.fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="primary">İptal</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">LNK</b-badge>

          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/5.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589019</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">Araştırma</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="success">Kabul</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SSI</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/no-image.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589018</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <span v-b-modal.wave3 class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2" v-b-tooltip.html title="<strong>Wave</strong>">
                  <i class="fas fa-water"></i>
                </span>
                <b-modal hide-footer :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="wave3" title="Wave">
                  <b-row>
                    <b-col xl="12">
                      <b-button v-b-modal.add_wave variant="primary" size="sm" class="fa-pull-right mb-3"><i class="fas fa-plus mr-2"></i> Ekle</b-button>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.items"
                          :fields="report.fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="danger">Red</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">2. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SLN</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/bilyoner.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589017</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <b-button id="message-share-box-4" class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2">
                  <i class="icon flaticon-chat"></i>
                </b-button>
                <b-popover target="message-share-box-4" triggers="hover" placement="top"  class="text-center">
                  <template v-slot:title><i class="far fa-comments mr-3"></i>Mesaj-Paylaş Kampanyası</template>
                  <div class="text-center">
                    <b-button-toolbar class="text-center table-vertical-center d-block">
                      <b-button-group size="sm" class="text-center">
                        <b-button @click="$router.push({name: 'ConfirmMessageShareCampaign'})" class="mr-2 btn-light-linkedin"><i class="fas fa-clipboard-check"></i> Onay</b-button>
                        <b-button @click="$router.push({name: 'ReportMessageShareCampaign'})" class="btn-light-linkedin"><i class="fas fa-clipboard-list"></i> Rapor</b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </div>
                </b-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">Araştırma</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="success">Kabul</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">3. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">LNK</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/7.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589016</strong> - <strong>1589023</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <span v-b-modal.wave4 class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2" v-b-tooltip.html title="<strong>Wave</strong>">
                  <i class="fas fa-water"></i>
                </span>
                <b-modal hide-footer :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="wave4" title="Wave">
                  <b-row>
                    <b-col xl="12">
                      <b-button v-b-modal.add_wave variant="primary" size="sm" class="fa-pull-right mb-3"><i class="fas fa-plus mr-2"></i> Ekle</b-button>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.items"
                          :fields="report.fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">Araştırma</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="success">Kabul</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">LNK</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/1.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589015</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <span v-b-modal.wave5 class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2" v-b-tooltip.html title="<strong>Wave</strong>">
                  <i class="fas fa-water"></i>
                </span>
                <b-modal hide-footer :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="wave5" title="Wave">
                  <b-row>
                    <b-col xl="12">
                      <b-button v-b-modal.add_wave variant="primary" size="sm" class="fa-pull-right mb-3"><i class="fas fa-plus mr-2"></i> Ekle</b-button>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.items"
                          :fields="report.fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">Araştırma</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="success">Kabul</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SSI</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/1.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589014</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <span v-b-modal.wave6 class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2" v-b-tooltip.html title="<strong>Wave</strong>">
                  <i class="fas fa-water"></i>
                </span>
                <b-modal hide-footer :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="wave6" title="Wave">
                  <b-row>
                    <b-col xl="12">
                      <b-button v-b-modal.add_wave variant="primary" size="sm" class="fa-pull-right mb-3"><i class="fas fa-plus mr-2"></i> Ekle</b-button>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.items"
                          :fields="report.fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="danger">Red</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SLN</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/2.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589013</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="danger">Red</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">LNK</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/3.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589012</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <b-button id="message-share-box-6" class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2">
                  <i class="icon flaticon-chat"></i>
                </b-button>
                <b-popover target="message-share-box-6" triggers="hover" placement="top"  class="text-center">
                  <template v-slot:title><i class="far fa-comments mr-3"></i>Mesaj-Paylaş Kampanyası</template>
                  <div class="text-center">
                    <b-button-toolbar class="text-center table-vertical-center d-block">
                      <b-button-group size="sm" class="text-center">
                        <b-button @click="$router.push({name: 'ConfirmMessageShareCampaign'})" class="mr-2 btn-light-linkedin"><i class="fas fa-clipboard-check"></i> Onay</b-button>
                        <b-button @click="$router.push({name: 'ReportMessageShareCampaign'})" class="btn-light-linkedin"><i class="fas fa-clipboard-list"></i> Rapor</b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </div>
                </b-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="primary">İptal</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SLN</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/4.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589011</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="danger">Red</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SLN</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/5.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589010</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <b-button id="message-share-box-8" class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2">
                  <i class="icon flaticon-chat"></i>
                </b-button>
                <b-popover target="message-share-box-8" triggers="hover" placement="top"  class="text-center">
                  <template v-slot:title><i class="far fa-comments mr-3"></i>Mesaj-Paylaş Kampanyası</template>
                  <div class="text-center">
                    <b-button-toolbar class="text-center table-vertical-center d-block">
                      <b-button-group size="sm" class="text-center">
                        <b-button @click="$router.push({name: 'ConfirmMessageShareCampaign'})" class="mr-2 btn-light-linkedin"><i class="fas fa-clipboard-check"></i> Onay</b-button>
                        <b-button @click="$router.push({name: 'ReportMessageShareCampaign'})" class="btn-light-linkedin"><i class="fas fa-clipboard-list"></i> Rapor</b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </div>
                </b-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">Araştırma</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="primary">İptal</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SSI</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/6.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589009</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <span v-b-modal.wave7 class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2" v-b-tooltip.html title="<strong>Wave</strong>">
                  <i class="fas fa-water"></i>
                </span>
                <b-modal hide-footer :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="wave7" title="Wave">
                  <b-row>
                    <b-col xl="12">
                      <b-button v-b-modal.add_wave variant="primary" size="sm" class="fa-pull-right mb-3"><i class="fas fa-plus mr-2"></i> Ekle</b-button>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.items"
                          :fields="report.fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="danger">Red</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">LNK</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/bilyoner.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589008</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"

                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">Araştırma</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="success">Kabul</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SSI</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/7.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589007</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-6 col-xl-4 mb-5">
      <!--begin::Card-->
      <div class="card card-custom wave wave-animate-slow wave-primary mb-8 mb-lg-0">
        <div class="card-body">
          <b-badge class="position-absolute offer-badge-top offer-left" variant="secondary">CRM</b-badge>
          <b-badge class="position-absolute offer-badge-top offer-right" variant="danger">Red</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-right" variant="warning">1. Wave</b-badge>
          <b-badge class="position-absolute offer-badge-bottom offer-left" variant="dark">SSI</b-badge>
          <div class="d-flex align-items-center p-5">
            <div class="mr-6 symbol symbol-circle symbol-lg-75">
              <img src="@/assets/media/project-logos/1.png" alt="image" width="70">
            </div>
            <div class="d-flex flex-column">
              <a class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                Bilyoner 2020
              </a>
              <div class="text-dark-75">
                <strong>1589006</strong> - Bilyoner.com 2020 Pazar Araştırması ...
              </div>
              <div class="mt-5">
                <router-link
                    to="edit-crm-offer"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.edit') + '</strong>'"
                >
                  <i class="icon flaticon-edit"></i>
                </router-link>
                <router-link
                    to="offer-delivery"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.delivery') + '</strong>'"
                >
                  <i class="icon flaticon2-paper-plane"></i>
                </router-link>
                <router-link
                    to="offer-report"
                    class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2"
                    v-b-tooltip.html :title="'<strong>' + $t('general.report') + '</strong>'"
                >
                  <i class="icon flaticon2-line-chart"></i>
                </router-link>
                <b-button id="message-share-box-10" class="btn btn-md btn-icon btn-light-linkedin btn-pill mx-2">
                  <i class="icon flaticon-chat"></i>
                </b-button>
                <b-popover target="message-share-box-10" triggers="hover" placement="top"  class="text-center">
                  <template v-slot:title><i class="far fa-comments mr-3"></i>Mesaj-Paylaş Kampanyası</template>
                  <div class="text-center">
                    <b-button-toolbar class="text-center table-vertical-center d-block">
                      <b-button-group size="sm" class="text-center">
                        <b-button @click="$router.push({name: 'ConfirmMessageShareCampaign'})" class="mr-2 btn-light-linkedin"><i class="fas fa-clipboard-check"></i> Onay</b-button>
                        <b-button @click="$router.push({name: 'ReportMessageShareCampaign'})" class="btn-light-linkedin"><i class="fas fa-clipboard-list"></i> Rapor</b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </div>
                </b-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-12 col-xl-12 mb-5">
      <!--begin::Pagination-->
      <div class="card card-custom">
        <div class="card-body py-7">
          <!--begin::Pagination-->
          <div class="d-flex justify-content-between align-items-center flex-wrap">
            <div class="d-flex flex-wrap mr-3">
              <a class="btn btn-icon btn-sm btn-light-primary mr-2 my-1">
                <i class="ki ki-bold-double-arrow-back icon-xs"></i>
              </a>
              <a class="btn btn-icon btn-sm btn-light-primary mr-2 my-1">
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </a>
              <a class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">...</a>
              <a class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">23</a>
              <a class="btn btn-icon btn-sm border-0 btn-hover-primary active mr-2 my-1">24</a>
              <a class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">25</a>
              <a class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">26</a>
              <a class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">27</a>
              <a class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">28</a>
              <a class="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">...</a>
              <a class="btn btn-icon btn-sm btn-light-primary mr-2 my-1">
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </a>
              <a class="btn btn-icon btn-sm btn-light-primary mr-2 my-1">
                <i class="ki ki-bold-double-arrow-next icon-xs"></i>
              </a>
            </div>
            <div class="d-flex align-items-center">
              <select class="form-control form-control-sm text-primary font-weight-bold mr-4 border-0 bg-light-primary" style="width: 75px;">
                <option value="18">18</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span class="text-muted">{{ $t('pagination.total_row_count', { total: '433', per_page : '10'})}}</span>
            </div>
          </div>
          <!--end:: Pagination-->
        </div>
      </div>
      <!--end::Pagination-->
    </div>
    <div class="clearfix"></div>
    <b-modal size="lg" id="edit_wave" title="2. Wave'i Düzenle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
      <b-row>
        <b-col xl="4">
          <b-form-group :label="$t('new_offer.unit_price')">
            <b-form-input
                type="number"
                value="6"
                class="form-control form-control-solid"
                :placeholder="$t('new_offer.unit_price')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col xl="4">
          <b-form-group :label="$t('new_offer.unit_price')">
            <b-form-input
                type="text"
                value="100"
                class="form-control form-control-solid"
                :placeholder="$t('new_offer.total_price')"
                disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col xl="4">
          <b-form-group :label="$t('new_offer.general_price')">
            <b-form-input
                value="600"
                type="text"
                class="form-control form-control-solid"
                :placeholder="$t('new_offer.general_price')"
                disabled
            ></b-form-input>
          </b-form-group>
        </b-col>

      </b-row>
    </b-modal>
    <b-modal size="lg" id="add_wave" title="Yeni Wave Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
      <b-row>
        <b-col xl="4">
          <b-form-group :label="$t('new_offer.unit_price')">
            <b-form-input
                type="number"
                class="form-control form-control-solid"
                :placeholder="$t('new_offer.unit_price')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col xl="4">
          <b-form-group :label="$t('new_offer.unit_price')">
            <b-form-input
                type="text"
                class="form-control form-control-solid"
                :placeholder="$t('new_offer.total_price')"
                disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col xl="4">
          <b-form-group :label="$t('new_offer.general_price')">
            <b-form-input
                type="text"
                class="form-control form-control-solid"
                :placeholder="$t('new_offer.general_price')"
                disabled
            ></b-form-input>
          </b-form-group>
        </b-col>

      </b-row>
    </b-modal>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "Offers",
  components: { DataTable, DashboardBox },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  data() {
    return {
      form : {
        country_id : null,
        customer_id : null,
        offer_status_id : null,
        month_id : null,
        year_id : null
      },
      show: true,
      countries: [{ text: this.$t('general.select'), value: null }, 'Türkiye', 'Almanya', 'Çin', 'Hindistan'],
      customers: [{ text: this.$t('general.select'), value: null }, 'BSH', 'BTA', 'Carat', 'Caretta İletişim', 'CarrefourSA', 'Coco Cola', 'Collective', 'Çanakçılar Seramik', 'D&R','Çiçek Sepeti'],
      offer_status: [{text: this.$t('general.select'), value: null}, 'Bekleyenler', 'Kabul Edilenler', 'Tamamlananlar', 'Reddedilenler', 'İptal Edilenler'],
      months : [
            {text: this.$t('general.select'), value: null},
            {text: 'Ocak', value: '01'},
            {text: 'Şubat', value: '02'},
            {text: 'Mart', value: '03'},
            {text: 'Nisan', value: '04'},
            {text: 'Mayıs', value: '05'},
            {text: 'Haziran', value: '06'},
            {text: 'Temmuz', value: '07'},
            {text: 'Ağustos', value: '08'},
            {text: 'Eylül', value: '09'},
            {text: 'Ekim', value: '10'},
            {text: 'Kasım', value: '11'},
            {text: 'Aralık', value: '12'},
          ],
      years: [{ text: this.$t('general.select'), value: null }, '2021', '2020', '2019', '2018','2017','2016','2015','2014','2013','2012'],

      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'id', label: 'Wave Numarası', sortable: true},
          {key: 'status', label: 'Durum', sortable: true},
          {key: 'wave_actions', label: 'İşlem', sortable: false},
        ],
      },
      table : {
        items : [
          {'id' : '1', 'status' : 'Tamamlandı', 'status_id' : '0'},
          {'id' : '2', 'status' : 'Tamamlandı', 'status_id' : '0'},
          {'id' : '3', 'status' : 'Aktif', 'status_id' : '1'},
          {'id' : '4', 'status' : 'Beklemede', 'status_id' : '4'},
          {'id' : '5', 'status' : 'Beklemede', 'status_id' : '4'},
          {'id' : '6', 'status' : 'Beklemede', 'status_id' : '4'},
        ],
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_1'), route: "alert" },
      { title: this.$t('offers.offers') }
    ]);
  }
}
</script>

<style scoped>
.offer-badge-top{
  top: 15px;
}
.offer-badge-bottom{
  bottom: 15px;
}
.offer-right{
  right: 15px;
}
.offer-left{
  left: 15px;
}
</style>
